// extracted by css-extract-rspack-plugin
export default {"input":"input-SdZ4sb","path":"path-RYJFv1","stroke":"stroke-AcB1RT","label":"label-xeaWbX","box":"box-Hzc3YU","title":"title-Rd0XlX","check":"check-L8cAX3","icon":"icon-Rw_iwH"};